import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'emotion-theming';
import { DarkPopup } from '@lyearn-team/frontend-components';
import themeConfig from '@lyearn-team/theme-config';

function unmount(node) {
  ReactDOM.unmountComponentAtNode(node);
  node && node.parentNode.removeChild(node);
}

function show(render) {
  return new Promise(resolve => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    function onCancel(response = true) {
      unmount(container);
      resolve(response);
    }

    const { props, children } = render({ onCancel });

    ReactDOM.render(
      <ThemeProvider theme={themeConfig}>
        <DarkPopup {...props} onCancel={() => onCancel(true)}>
          {children}
        </DarkPopup>
      </ThemeProvider>,
      container
    );
  });
}

const ImperativePopupDark = { show };
export default ImperativePopupDark;
